import React, { useState, useRef, useEffect } from "react";
import { Box, Button, Stack, Typography } from "@mui/joy";
import CustomTypography from "../../../common/CustomTypography";
import { theme } from "styles/theme";
import fivestarsImg from "static/image/onboarding/fivestars_yellow.svg";
import appstoreIconImg from "static/image/payment/appstore_icon.png";
import googleplayIconImg from "static/image/payment/googleplay_icon.png";
import plusIconImg from "static/image/payment/plus_icon_m.svg";

const reviews: ReviewItem[] = [
  {
    source: "App Store",
    content:
      "나는 마음이 힘들때 자기개발서 책을 많이 읽었었다. 읽을땐 책에 나온대로 해봐야겠다 생각을 하지만 며칠이 지나면 까먹게 되고 원래 잡생각이 많고 불안 걱정이 많은 나로 돌아왔다. 그게 쌓이고 쌓여 마음이 또 힘들어질땐 자기개발서를 읽고 반복이었다. 디스턴싱은 매일매일 나에게 활동지를 주고 매일 생각과 분리하는 연습을 시켜준다. 이렇게 매일 연습하다보면 마음에 습관이 되어 책읽는거보다 긍정적인 효과를 줄수있을것같다",
    name: "호이미미",
    date: "2026-01-23",
  },
  {
    source: "App Store",
    content:
      "어려서부터 '생각이 너무 많다'는 말을 들어왔는데, 이 프로그램을 통해 생각의 파트를 분리해보며 정돈되어 가는 듯해요. 그리고 스스로 어느정도 알고있다고 생각한 '나'에 대해서도 새롭게 배우고 있어요. 100일동안 같이 훈련하며 무언가 해볼 힘을 다시 길러볼 수 있을 것 같아요.",
    name: "구름으로",
    date: "2026-01-22",
  },
  {
    source: "App Store",
    content:
      "어디에도 기댈 곳이 없고, 털어놓을 곳이 없어서 혼자 버티는 느낌이었어요. 집도 회사도, 모든 인간관계가요. 디스턴싱은 단순히 들어주는 것이 아니라 내가 스스로 놓치고 있던 감정들이나 지점을 코치님이 딱 짚어주십니다. '아 내가 이 부분에서 유독 약했구나' 하고 알게 되는 순간들이 있었어요. 정리되지 않은 마음 그대로 꺼내도 핵심을 짚어주는 디테일한 코칭이 인상적입니다. 혼자 정리하기 어려운 마음을 차분하게 돌아볼 수 있어서 조용한 위로가 되었어요.",
    name: "조용한물멍",
    date: "2026-01-21",
  },
  {
    source: "Google Play",
    content:
      "디스턴싱 앱을 일주일 간 사용해 보니, 그동안 감정 관리에 대해 새로운 인사이트를 얻어가서 좋았어요! 저는 평소에 짜증도 많고 우울한 감정에 자주 휘둘리는 성격이었어요. 그런데 코치님께서 그런 감정들을 잘못됐다고 없애는 것이 아니라 그냥 거리를 두고 알아차리는 것만으로도 마음을 다스리는데 도움이 된다고 하셔서 실천해 보니까 훨씬 마음이 편해졌어요! 제가 정신과도 다녀보고, 심리상담도 받아봤는데 어느 순간 제가 먼저 이야기를 꺼내야 한다는 게 부담이더라고요. 어떤 이야기를 해야 할지 모르겠고, 저조차도 제 감정을 말로 설명하기 어려웠어요. 그런데 하루에 하나씩 활동지를 해나가면서 저에게 맞는 속도로 조금씩 마음에 대해 배워가고 있어서 좋아요. 코치님께서도 제 이야기에 대해 판단하지 않으시고 그저 제 상황에 적절한 도움을 주려고 하시는 것 같아서 마음이 편했어요😊 앞으로 남은 90일동안 제가 얼마나 달라질지 기대돼요. 생각을 나와 분리하는 연습이 필요하신 분께 강추드립니다!!",
    avatarImg:
      "https://play-lh.googleusercontent.com/a-/ALV-UjUaZRItUCyMaaTI4-Zg_SVkmrQQx7w1FyWrV9Fh7Y8CCpZiUXmW",
    name: "슈품",
    date: "2026-01-18",
  },
  {
    source: "App Store",
    content:
      "저는 상담을 다니면서도 불안함을 떨칠수 없었어요 자기 확신이 없어서 끊임없이 생각하고 그 생각이 저를 공격하게 두었어요 디스턴싱을 접하고 불안을 내가 끊어내고 멀리하려면 연습을 해야한다는것을 알았어요 매일 학습지처럼 읽고 생각하고 연습하다보니 정말 불안이 많이 줄었어요! 불안함에 공황까지 겪으신분들! 약만이 답이아니에요 근본은 마음을 다독거리고 내 마음을 자꾸 봐야해요 디스턴싱으로 함께 연습해요☺️🩶🩶",
    name: "쥐는콩",
    date: "2026-01-14",
  },
  {
    source: "App Store",
    content:
      "요 근래 몇년간 마음이 편하질 않아서 뭐라도 해보고싶은 마음에 큰 기대없이 시작했는데, 생각보다 도움이 많이 됩니다. 한발자국씩 천천히 따라갈 수 있는 친절한 설명이 참 좋습니다. 주변에도 추천하고 있어요:)",
    name: "D.G.me.",
    date: "2026-01-13",
  },
  {
    source: "Google Play",
    content:
      "심리상담에 가는 것보다 좋다. 1. 집에서도 간편하게 가능함 2. 상담에 다니면 하루에 1시간 반~2시간은 소모되는데 그런게 없다. 3. 상담에 가면 감정적으로 쏟아내게 되어 불필요한 시간이 많은데 그런게 없다. 4. 객관적으로 상황, 감정을 기술하게 되어있어 스스로를 돌아보기 좋다.",
    name: "su su",
    date: "2026-01-12",
  },
  {
    source: "App Store",
    content:
      "아직 일주일밖에 안됐지만 여기저기서 튀어오르는 생각을 정리하고, 기록해보는 것 만으로도 도움이 돼요. 코치 선생님께서 마음 상태를 스스로 깨달을 수 있게 질문으로 잘 이끌어주시는 점이 좋습니다.",
    name: "요얍룝얒",
    date: "2026-01-12",
  },
  {
    source: "App Store",
    content:
      "정신과 진료보기전에 최후의 방법으로 이용해본 어플. 비용이 부담될 수 있지만 심리적인 안정을 많이 찾았다. 평생 살아가야 하는 인생에서...생각에 휘둘리고 빠져나올 수 없는 고통의 시간들을 조금이라도 줄여주는데 도움이 된다면 그것만으로도 이 어플의 가치는 충분한 것 같다.",
    name: "myeunj",
    date: "2026-01-12",
  },
  {
    source: "App Store",
    content:
      "가격이 비싸지만 그 값을 해요. 더 침착해졌어요. 감정도 되돌아보게 도와주고, 조절하는 방법도 배웠어요. 힘들때 자연스럽게 앱을 켜게 되는 것 같아요",
    name: "수수찡찡",
    date: "2026-01-03",
  },
  {
    source: "Google Play",
    content:
      "최근 나를 더 보살펴야 겠다는 생각으로 디스턴싱을 구매했습니다 사실 저에게는 조금 부담되는 가격이었지만 그래도 나를 위해 한번쯤 소비하자 라는 생각으로 결제하고 약 2-3주정도 진행을 해오고 있는데, 생각보다 도움을 많이 받고 있습니다. 평소 일기를 잘 쓰지 않는 편인데, 매일 생각기록을 하면서 내 감정을 기록하는 습관도 길러지는것 같습니다. 코치님께서 피드백 해주시는 부분도 생각보다 심리적 안정감에 큰 도움이 됩니다. 항상 생각을 스위치 처럼 끄고 킬수 있으면 좋겠다고 생각해온편이었는데, 다른 방식으로 생각과 나를 분리하는 연습을 해보니 새롭습니다.",
    name: "aa A",
    date: "2025-12-28",
  },
  {
    source: "App Store",
    content:
      "디스턴싱 3개월 하면서 완전히 달라졌습니다. 이렇게 말하면 디스턴싱이 마치 만병통치약이라도 되는 것처럼 '불안하고 우울한 증상이 안 생기는 걸까?' 라고 생각하실 수 있는데 제 삶에 여전히 불안과 우울은 존재하지만 받아들이는 태도가 완전히 달라졌어요. 심리 상담도 1년 가까이 받았는데 디스턴싱을 했던 3개월이 훨씬 더 효과적이었어요. 디스턴싱을 하면서 누구에게도 말 못할 감정과 생각들을 정말 솔직하게 기록했고 코치 님과 나누면서 수년동안 나를 괴롭혔던 반복된 생각 패턴을 찾게 됐습니다. 어떤 상황에 어떤 생각이 드는지 깨닫는 것이 좋은 출발점이었어요. 현재는 내가 나와 가장 친한 친구가 되어 스스로를 돌볼 줄 알게 됐다는 점이 가장 만족스럽습니다! 우연히 인스타 광고를 보고 시작했는데 그 선택을 한 내 자신을 칭찬해요. 그 순간의 용기로 제 인생이 바뀌었으니까요! 앱 개발해 주셔서 감사합니다 👍🏻 홍승주 대표님이 쓰신 책도 추천합니다.",
    name: "atta dipa",
    date: "2025-12-26",
  },
  {
    source: "Google Play",
    content:
      "이 앱을 사용한지 일주일 되었는데 정말 유익한 앱이에요 심리상담은 일주일에 한번만 하지만 이건 매일 언제든지 필요할때 이용할수있어서 더 도움이 될것같아요 앞으로 기대가 됩니다.",
    avatarImg:
      "https://play-lh.googleusercontent.com/a-/ALV-UjUquAidcqSEEIWnFZHQZhFzjlY2H_Utb_TzKDokJAFzYlsi-kA1",
    name: "wj Park",
    date: "2025-12-22",
  },
  {
    source: "App Store",
    content:
      "디스턴싱을 시작하면서 내 마음에 이전과는 다른 여유가 생기기 시작했다. 예전에는 부정적인 감정이 올라오면 그 감정에 그대로 휩쓸려 스스로를 몰아붙이거나, 감정을 억누르며 버티는 경우가 많았다. 하지만 지금은 그 감정을 '나 자신'으로 동일시하기보다 한 걸음 떨어져 바라볼 수 있게 되었다는 점이 가장 큰 변화다. 부정적인 마음이 들 때마다 그것을 외면하지 않고 기록하고, 그 감정이 왜 생겼는지, 어떤 생각에서 비롯된 것인지를 코칭을 통해 차분히 들여다보는 시간이 도움이 많이 되었다. 그 과정은 마치 마음속에 쌓아두었던 이야기들을 대나무숲에 털어놓는 것처럼 솔직하고 후련한 경험이었다. 누군가에게 이해받고 정리된 언어로 되돌려 받으면서 감정의 무게가 자연스럽게 가벼워지는 느낌을 자주 받았다. 특히 좋았던 점은 부정적인 감정이 생겼을 때 그것을 없애려 애쓰기보다, '아, 지금 이런 마음이 올라오고 있구나' 하고 있는 그대로 인정할 수 있게 되었다는 것이다. 그 덕분에 감정에 끌려 반응하기보다 나에게 조금 더 친절한 선택을 할 수 있는 여지가 생겼다. 이제는 예전보다 나 자신을 더 믿게 되었고, 앞으로의 나에 대한 기대감도 커졌다. 완벽해지지 않아도 괜찮고, 흔들리더라도 다시 중심을 찾을 수 있다는 안정감이 마음 깊은 곳에 자리 잡아가고 있다. 건강한 정신과 마음으로 살아갈 나의 시간이 이미 시작되었고, 그 앞으로의 과정이 조용히, 그러나 분명하게 기다려진다.",
    name: "회원니임",
    date: "2025-12-22",
  },
  {
    source: "App Store",
    content:
      "커피 한 잔 값으로 선생님께 코칭을 받는다고? 처음엔 반신반의했어요. 100일분을 한 번에 결제하는 건 사실 부담스럽기도 했고요. 하지만 제 생각에 잠겨 눈앞의 일들을 잘 처리하지 못하고 있다는 판단이 들어, 용기를 내어 프로그램을 수강하게 되었습니다. 하루 30분 정도만 투자하면 되고, 집에서 혼자 명상하며 하면 가장 좋지만 그렇지 않더라도 활용할 수 있는 점이 마음에 들었어요. 출퇴근길이나 약속 전 대기 시간, 혹은 내가 원하는 순간에 언제 어디서든 양식을 작성할 수 있다는 점이 큰 장점이었습니다. 솔직히 '한 번 결제하고 돈만 날리는 건 아닐까?' 걱정했는데, 대중교통을 이용하면서도 활용할 수 있어 생각보다 훨씬 잘 쓰고 있네요. 또 깜빡하고 작성하지 않을 수도 있는데, 알림 설정 덕분에 '아, 내가 이거 결제했지!' 하며 다시 하게 되는 것도 좋습니다. 무엇보다 좋았던 점은 선생님께 제 생각을 솔직하게 털어놓을 수 있다는 거예요. 실제로 대화할 때는 상대방의 반응을 살피느라 말하지 못하는 경우가 많지만, 여기서는 사소한 것이라도 편하게 올릴 수 있어 마음이 한결 가벼워집니다. 현재 수강한 지 약 20일 정도 되었는데, 조금씩 '생각을 대하는 방법'을 배우고 있는 것 같아 만족스럽습니다. 부담 없이 꾸준히 이어갈 수 있는 프로그램이라 생각보다 할 만하네요.",
    name: "별하늘아이12",
    date: "2025-12-21",
  },
  {
    source: "App Store",
    content:
      "나의 상황과 생각들을 되돌아 볼 수 있는 획기적인 도구이며 매우 편리합니다. 처음 이 앱을 결제하고 사용할때까진 회의적인 편이었지만 직관적이고 꾸밈없는 질문들에 점점 더 대답하기 수월해지고 마음이 편해지며 생각들이 정리 되는 것을 느끼실 겁니다. 요즘 우울감이 많이 커져서 정신 과의 도움을 받고자 했었는데 병원을 알아봐도 초진은 기본 3주는 기다려야 했었고 그 상황마다 좌절하고 더 깊은 우울감에 빠져 결국 병원 진료를 포기하게 됐었습니다. 그러다 이 앱을 발견하여 시작해 봤는데 아직은 초기 단계지만 마음이 힘들때나 나의 감정들을 돌아보고 싶을때 사용할 수 있는 도구가 있다는 것에 든든합니다. 나와 가까운 친구나 가족이 아닌 타인에게 나의 얘기를 할수있고 전문적인 도움도 함께 받을 수 있어 좋습니다. 앞으로 더 꾸준히 사용해 볼 예정입니다.",
    name: "Prinnceesss",
    date: "2025-12-20",
  },
  {
    source: "App Store",
    content:
      "대학생이라 디스턴싱을 결재하기에 금액이 너무 부담돼서 일주일 넘게 망설였었어요. 그래도 직접 상담 다니는 것보다는 훨씬 저렴하니 한번 해보자하고 시작했는데, 정말 피같은 제 알바비 하나도 아깝지 않습니다. 오히려 3개월 더 연장해서 하고 싶어요!! 🥹 항상 우울과 불안이 높아서 우울증 약까지 복용해 봤지만 일상생활 속에서 행동이나 생각이 교정되지 않으니 약은 그닥 효과가 없었어요. 하지만 디스턴싱은 제가 스스로 저의 생각과 행동을 교정할 수 있게 되니 내 앞으로 평생을 교정하는 느낌이 딱 들어요. 지금 당장 힘든 것 뿐만아니라 앞으로는 이렇게 힘들 일이 없게 해주는 느낌.. 너무 좋습니다.. 다들 돈 아깝다 생각하지 마시고 본인을 위한 투자니 아끼지 마시고 꼭 해보셨으면 좋겠어요,,",
    name: "hehohg",
    date: "2025-12-17",
  },
  {
    source: "Google Play",
    content:
      "마음공부를 이것저것 기웃거리며 뜬구름잡듯이 보고있다가 알게된 디스턴싱입니다. 처음엔 의심가득으로 환불할까말까 망설였는데 코치님의 응원과 진도에 대한 피드백으로 점점 확신을 갖는중입니다. 요동쳤던 나의 마음과 생각들이 점점 굴곡이 완만해지는 느낌을 받고있습니다. 디스턴싱이 아무래도 글로만 진행되니까 홍승주선생님의 유튜브 영상과 함께하면 더 시너지를 얻을 수 있어 좋습니다.",
    name: "조이파니",
    date: "2025-12-16",
  },
  {
    source: "Google Play",
    content:
      "직장생활에 마음이 너무 힘들어서 도움을 받고싶어 가입했는데, 제상황을 객관적으로 벽에 붙여놓듯 바라볼 수있게 도와준 프로그램인것같아요 현재는 조금씩 마음이 힘들었던게 나아지고있고, 남은 프로그램은 직장뿐아니라 개인적인 영역도 함께 코칭을 받아보고싶은 마음이있어요.",
    avatarImg:
      "https://play-lh.googleusercontent.com/a-/ALV-UjUBLiVd794z1EzPMTJJM5NJ-JtGAUory5HKjUHTk8P57srZioHc",
    name: "고현경",
    date: "2025-12-16",
  },
  {
    source: "App Store",
    content:
      "바로바로 저에게 도움이 되고 효과가 나타나서 정말 놀랍습니다. 불안이나 두려움 과거 기억에 사로잡혀있다면 추천합니다.",
    name: "가루가메",
    date: "2025-11-25",
  },
  {
    source: "Google Play",
    content:
      "디스턴싱을 통해 확실히 마음이 더 차분해지고 감정이나 생각에 얽매여 시간을 쓰거나 괴롭지 않게 됐어요. 앞으로의 배움도 기대돼요 ㅎㅎ 이런 서비스를 만들어주셔서 진심으로 감사해요!!",
    name: "anything",
    date: "2025-11-18",
  },
  {
    source: "App Store",
    content:
      "디스턴싱을 시작하고 처음으로 내가 하는 생각이 얼마나 임의적인데 매번 휘둘리고 괴로워했나 자각했습니다. 조금더 연습해서 나의 평화로운 모습만 되찾아나간다면 새로운 나에게 닻을 내릴수 있으리라는 희망이 생깁니다.",
    name: "헤라마미",
    date: "2025-10-19",
  },
];

export interface ReviewItem {
  source: "App Store" | "Google Play";
  content: string;
  avatarImg?: string;
  name: string;
  date: string;
}

interface ReviewSectionProps {
  initialDisplayCount?: number;
  incrementCount?: number;
  maxContentLength?: number;
}

const ReviewCard = ({ review }: { review: ReviewItem }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const sourceIcon =
    review.source === "App Store" ? appstoreIconImg : googleplayIconImg;

  // Get first character of name for avatar fallback
  const avatarInitial = review.name.charAt(0);

  // Format date from "YYYY-MM-DD" to "YYYY.MM.DD."
  const formattedDate = review.date.replace(/-/g, ".") + ".";

  // Check if content overflows 5 lines
  useEffect(() => {
    if (contentRef.current) {
      const element = contentRef.current;
      setIsOverflowing(element.scrollHeight > element.clientHeight);
    }
  }, [review.content]);

  return (
    <Stack spacing={"20px"} alignItems="center" sx={{ width: "100%" }}>
      {/* 5 Stars */}
      <Box sx={{ height: "24px", width: "124px" }}>
        <img
          src={fivestarsImg}
          alt="5 stars"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>

      {/* Review Content */}
      <Stack sx={{ width: "100%", maxWidth: "660px", px: "4px" }}>
        <Box>
          <Typography
            ref={contentRef}
            variant="Body"
            sx={{
              fontWeight: 500,
              color: theme.vars.palette.Content.Medium,
              textAlign: "center",
              display: "-webkit-box",
              WebkitLineClamp: isExpanded ? "unset" : 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              wordBreak: "keep-all",
            }}
          >
            {review.content}
          </Typography>
          {isOverflowing && (
            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant={"Body"}
                onClick={() => setIsExpanded(!isExpanded)}
                sx={{
                  py: 0,
                  fontWeight: 500,
                  color: theme.vars.palette.Content.Highlight,
                  cursor: "pointer",
                }}
              >
                {!isExpanded && "더 보기"}
              </Typography>
            </Box>
          )}
        </Box>
      </Stack>

      {/* User Info */}
      <Stack direction="row" spacing={"8px"} alignItems="center">
        {/* Avatar with Source Icon */}
        <Box sx={{ position: "relative", width: "32px", height: "32px" }}>
          {review.avatarImg ? (
            <Box
              sx={{
                width: "32px",
                height: "32px",
                borderRadius: "100px",
                overflow: "hidden",
                border: `1px solid rgba(32, 39, 43, 0.04)`,
              }}
            >
              <img
                src={review.avatarImg}
                alt={review.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                width: "32px",
                height: "32px",
                borderRadius: "100px",
                backgroundColor: theme.vars.palette.Content.SuperWeak,
                border: `1px solid rgba(32, 39, 43, 0.04)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant={"Subtitle"}
                sx={{
                  fontWeight: 500,
                  color: theme.vars.palette.Content.Negative,
                }}
              >
                {avatarInitial}
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              position: "absolute",
              right: "-3px",
              bottom: "-3px",
              width: "16px",
              height: "16px",
              borderRadius: "5px",
              overflow: "hidden",
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={sourceIcon}
              alt={review.source}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>

        {/* Name and Date */}
        <Stack>
          <Typography
            variant={"Caption"}
            sx={{
              fontWeight: 500,
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {review.name}
          </Typography>
          <Typography
            variant={"Footnote"}
            sx={{
              fontWeight: 400,
              color: theme.vars.palette.Content.Weak,
            }}
          >
            {formattedDate}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default function ReviewSection({
  initialDisplayCount = 3,
  incrementCount = 3,
}: ReviewSectionProps) {
  const [displayCount, setDisplayCount] = useState(initialDisplayCount);

  const visibleReviews = reviews.slice(0, displayCount);
  const hasMore = displayCount < reviews.length;

  const handleShowMore = () => {
    setDisplayCount((prev) => Math.min(prev + incrementCount, reviews.length));
  };

  return (
    <Stack
      spacing={"40px"}
      alignItems="center"
      sx={{
        backgroundColor: theme.vars.palette.Background.Level1,
        width: "100%",
        px: "36px",
        py: "80px",
      }}
    >
      {/* Title */}
      <CustomTypography
        variant="H2"
        sx={{
          fontWeight: 700,
          color: theme.vars.palette.Content.Strong,
          textAlign: "center",
        }}
      >
        {"1000+개의 5점 후기가\n" + "증명하는 효과"}
      </CustomTypography>

      {/* Review Cards */}
      {visibleReviews.map((review, index) => (
        <ReviewCard key={index} review={review} />
      ))}

      {/* Show More Button */}
      {hasMore && (
        <Button
          variant="Outlined"
          color={"primary"}
          size="md"
          onClick={handleShowMore}
          startDecorator={
            <img
              src={plusIconImg}
              alt="plus"
              style={{ width: "20px", height: "20px" }}
            />
          }
          sx={{
            "--Button-gap": "4px",
            fontWeight: 700,
            maxWidth: "660px",
            width: "100%",
            height: "48px",
            boxShadow: `inset 0 0 0 1.4px ${theme.vars.palette.Border.Highlight}`,
          }}
        >
          더 많은 후기 보기
        </Button>
      )}
    </Stack>
  );
}
